module.exports = __webpack_public_path__ + "static/media/TBSDrifireFRCareInstructions.a78bcb31.pdf";